/** Walk up from anchor and collect elements that can scroll (overflow auto/scroll). */
export function scrollableAncestors(el: HTMLElement | null): HTMLElement[] {
  const out: HTMLElement[] = [];
  let node = el?.parentElement ?? null;
  while (node) {
    const { overflow, overflowX, overflowY } = window.getComputedStyle(node);
    const ox = overflowX || overflow;
    const oy = overflowY || overflow;
    if (/(auto|scroll)/.test(ox) || /(auto|scroll)/.test(oy)) {
      out.push(node);
    }
    node = node.parentElement;
  }
  return out;
}

export type AnchorDropdownPosition = { top: number; left: number };

/**
 * Viewport-fixed menu aligned to the anchor (right edge for desktop, left for mobile).
 */
export function computeFixedDropdownNearAnchor(
  anchor: HTMLElement,
  opts: { isMobile: boolean; dropdownWidth: number; dropdownHeight: number },
): AnchorDropdownPosition | null {
  const rect = anchor.getBoundingClientRect();
  if (rect.width < 1 && rect.height < 1) return null;
  const { isMobile, dropdownWidth, dropdownHeight } = opts;
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  let left = isMobile ? rect.left : rect.right - dropdownWidth;
  if (left < 8) left = 8;
  if (left + dropdownWidth > vw - 8) left = Math.max(8, vw - dropdownWidth - 8);
  const preferredTop = rect.bottom + 4;
  let top = preferredTop;
  if (preferredTop + dropdownHeight > vh - 8) {
    top = Math.max(8, rect.top - dropdownHeight - 4);
  }
  if (top + dropdownHeight > vh - 8) {
    top = Math.max(8, vh - dropdownHeight - 8);
  }
  return { top, left };
}
